import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion";
import AccordionSection from "@insite/mobius/AccordionSection";
import Clickable from "@insite/mobius/Clickable";
import Drawer, { DrawerPresentationProps } from "@insite/mobius/Drawer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
import Icon from "@insite/mobius/Icon";
import Filter from "@insite/mobius/Icons/Filter";
import X from "@insite/mobius/Icons/X";
import Modal from "@insite/mobius/Modal";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import filterDrawer from "@tSurya/Handlers/FilterDrawer";
import CustomApplicationState from "@tSurya/Store/Data/CustomApplicationState/CustomApplicationState";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import React, { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css, ThemeProps, withTheme } from "styled-components";

interface State {
    createListModalIsOpen: boolean;
}
const enum fields {
    hideFilterCheckbox = "hideFilterCheckbox",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.hideFilterCheckbox]: boolean;
    }
}
const mapStateToProps = (state: CustomApplicationState) => ({
    displayFilter: state.SURData.toggleFilter?.filterData,
    categoryFacets: getProductListDataViewProperty(state, "categoryFacets"),
    isCategoryPage: state.pages.productList.productFilters.pageCategoryId !== undefined,
    headerHeight: state.SURData.headerHeightStore.headerHeight,
    location: getLocation(state),
    filterState:state.SURData.filterDrawerReducer?.filterModal
});
const mapDispatchToProps = {
    filterDrawer
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> ;

export interface ProductListColumnsStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    leftColumnFilterHideGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnFullWidthGridItem?: GridItemProps;
    leftColumnAccordionStyle?: AccordionPresentationProps;
    filterIconStyle?: InjectableCss;
    drawerClose?: InjectableCss;
    attributeContainer?: InjectableCss;
    mobFilterIconStyle?: InjectableCss;
    mobFilterContainer?: InjectableCss;
    closeMobFilterIconStyle?: InjectableCss;
    isCompactHeaderFlyout?: boolean;
    filterDrawer?: DrawerPresentationProps;
}

export const columnsStyles: ProductListColumnsStyles = {
    container: {
        gap: 22,
        css: css`
            overflow: hidden;
        `,
    },
    closeMobFilterIconStyle: {
        css: css`
            display: block;
            height: 20px;
            width: 20px;
            margin-right: 4px;
        `,
    },
    leftColumnGridItem: {
        width: [12, 12, 12, 3, 3],

        css: css`
            @keyframes slideInFromLeft {
                0% {
                    transform: translateX(-100%);
                }
                100% {
                    transform: translateX(0);
                }
            }
            animation: 1s ease-out 0s 1 slideInFromLeft;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: block;
                        `,
                        css`
                            display: block;
                        `,
                        css`
                            display: block;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            > div {
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        null,
                        null,
                        null,
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                    ]);
                }}
            }
        `,
    },
    leftColumnFilterHideGridItem: {
        width: 0,
    },
    rightColumnGridItem: {
        width: [12, 12, 12, 9, 9],
        css: css`
            @keyframes slideInFromRight {
                0% {
                    transform: translateX(50%);
                }
                100% {
                    transform: translateX(0);
                }
            }
            animation: 1s ease-out 0s 1 slideInFromRight;
        `,
    },
    rightColumnFullWidthGridItem: {
        width: 12,
        css: css`
            transition: all 1s ease-in-out;
        `,
    },
    drawerClose: {
        css: css`
            display: flex;
            justify-content: space-between;
            background-color: #fff;
            padding: 18px 20px;
        `,
    },
    attributeContainer: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.bold};
            font-size: ${TYPOGRAPHY.size.small};
            line-height: ${TYPOGRAPHY.lineHeight.base};
            color: ${getColor("text.main")};
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-family: ${TYPOGRAPHY.fontFamily.title};
                            font-style: normal;
                            font-weight: ${TYPOGRAPHY.weight.bold};
                            font-size: ${TYPOGRAPHY.size.small};
                            line-height: ${TYPOGRAPHY.lineHeight.base};
                            color: ${getColor("text.main")};
                            text-transform: uppercase;
                        `,
                        css`
                            font-family: ${TYPOGRAPHY.fontFamily.title};
                            font-style: normal;
                            font-weight: ${TYPOGRAPHY.weight.bold};
                            font-size: ${TYPOGRAPHY.size.small};
                            line-height: ${TYPOGRAPHY.lineHeight.base};
                            color: ${getColor("text.main")};
                            text-transform: uppercase;
                        `,
                        css`
                            font-family: ${TYPOGRAPHY.fontFamily.title};
                            font-style: normal;
                            font-weight: ${TYPOGRAPHY.weight.bold};
                            font-size: ${TYPOGRAPHY.size.small};
                            line-height: ${TYPOGRAPHY.lineHeight.base};
                            color: ${getColor("text.main")};
                            text-transform: uppercase;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    filterIconStyle: {
        css: css`
            display: none;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            display: block;
                            position: absolute;
                            top: 12px;
                            left: 10px;
                            height: 20px;
                            width: 20px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    mobFilterIconStyle: {
        css: css`
            display: none;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: block;
                            height: 20px;
                            width: 20px;
                            margin-right: 10px;
                        `,
                        css`
                            display: block;
                            height: 20px;
                            width: 20px;
                            margin-right: 10px;
                        `,
                        css`
                            display: block;
                            height: 20px;
                            width: 20px;
                            margin-right: 10px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    mobFilterContainer: {
        css: css`
            display: flex;
            padding: 11px 22px;
            background-color: ${getColor("common.backgroundContrast")};
            border: 1px solid ${getColor("primary")};
            width: 100%;
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.bold};
            font-size: ${TYPOGRAPHY.size.base};
            line-height: ${TYPOGRAPHY.lineHeight.xbase};
            color: ${getColor("text.main")};
            &:focus {
                outline-width: 0px;
            }
        `,
    },
    filterDrawer: {
        position: "left",
        size: 350,
        closeButtonProps: {
            shape: "pill",
            buttonType: "solid",
            color: "common.background",
            size: 36,
            css: css`
                display: none;
            `,
        },
        cssOverrides: {
            drawerTitle: css`
                background: ${getColor("common.background")};
                position: absolute;
                align-self: flex-end;
            `,
            drawerContent: css`
                padding: 0 0 0 0;
            `,
            drawerBody: css`
                background: ${getColor("common.background")};
                /* padding-left: 20px; */
            `,
            headlineTypography: css`
                margin: 15px 0 15px 30px;
            `,
        },
        headlineTypographyProps: {
            color: "text.main",
        },
    },

    leftColumnAccordionStyle: {
        css: css`
            width: 100%;
            > dt {
                button {
                    display: none;
                }
            }
            > dd {
                border: none;
            }
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [null, null, null, null, null], "max");
            }}
        `,
    },
};

const styles = columnsStyles;

const ProductListColumns: FC<Props & ThemeProps<BaseTheme>> = ({
    id,
    displayFilter,
    theme,
    isCategoryPage,
    categoryFacets,
    location,
    headerHeight,
    filterDrawer,
    filterState,
    fields
}) => {
    // if (!isCategoryPage || !categoryFacets?.length) {
    //     return null;
    // }

    const [isAccordion, setAccordion] = React.useState(false);
    const [isAccordionExpanded, setAccordionExpanded] = React.useState(false);
    const [createListModalIsOpen, setCreateListModalIsOpen] = useState(false);

    React.useEffect(() => {
        const setAccordionState = () => {
            if (window.innerWidth < theme.breakpoints.values[3]) {
                setAccordion(true);
            } else {
                setAccordion(false);
            }
        };
        setAccordionState();

        const onWindowResize = () => {
            setAccordionState();
        };

        window.addEventListener("resize", onWindowResize);
        onWindowResize();

        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    });
    React.useEffect(()=>{
        filterDrawer({filterModal:false})
    },[displayFilter])

    React.useEffect(()=>{
        filterDrawer({filterModal:false})
    },[location])

    const onClickFilterSection = (_accordionExpanded: boolean) => () => {
        setAccordionExpanded(!_accordionExpanded);
    };

    const buttonClickHandler = () => {
        useState({ createListModalIsOpen: true });
    };
    const modalCloseHandler = () => {
        useState({ createListModalIsOpen: false });
    };

    const filterDrawerCloseHandler = () => {
        filterDrawer({filterModal:false})
       
    };
    const clickFilterIconHandler = () => {
        filterDrawer({filterModal:!filterState})

    };

    const leftColumnGridItemStyle = displayFilter || fields.hideFilterCheckbox? styles.leftColumnFilterHideGridItem : styles.leftColumnGridItem;
    const rightColumnGridItemStyle = displayFilter || fields.hideFilterCheckbox ? styles.rightColumnFullWidthGridItem :styles.rightColumnGridItem ;
  
    return (
        <GridContainer {...styles.container}>
            {!displayFilter && (
                <GridItem {...leftColumnGridItemStyle} data-test-selector="productListLeftCoulmn">
                    <Hidden below="md">
                        <Accordion
                            headingLevel={4}
                            {...styles.leftColumnAccordionStyle}
                            className="accordionFilterStyle"
                        >
                            <Icon src={Filter} {...styles.filterIconStyle} />
                            <AccordionSection
                                title="Filter"
                                {...(!isAccordion ? { expanded: true } : { expanded: isAccordionExpanded })}
                                onTogglePanel={onClickFilterSection(isAccordionExpanded)}
                            >
                                <Zone contentId={id} zoneName="Content00" />
                            </AccordionSection>
                        </Accordion>
                    </Hidden>

                    <Hidden above="md">
                        <Clickable
                            {...styles.mobFilterContainer}
                            onClick={clickFilterIconHandler}
                            data-test-selector="productListFilterButton"
                        >
                            <Icon src={Filter} {...styles.mobFilterIconStyle} />
                            Filter
                        </Clickable>
                        <Drawer
                            {...styles.filterDrawer}
                            isOpen={filterState}
                            handleClose={filterDrawerCloseHandler}
                            data-test-selector="productListFilterDrawer"
                            style={{marginTop:`${headerHeight}px`}}
                        >
                            <StyledWrapper {...styles.drawerClose}>
                                <StyledWrapper {...styles.attributeContainer}> Filter </StyledWrapper>
                                <Icon src={X} {...styles.closeMobFilterIconStyle} onClick={filterDrawerCloseHandler} />
                            </StyledWrapper>
                            <StyledWrapper css={css`margin-bottom: 100px; padding-bottom:${headerHeight}px`}>
                                <Zone zoneName="Container" contentId={id} />
                            </StyledWrapper>
                        </Drawer>
                    </Hidden>
                </GridItem>
            )}

            <GridItem {...rightColumnGridItemStyle}>
                <Zone contentId={id} zoneName="Content01" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps,mapDispatchToProps)(withTheme(ProductListColumns)),
    definition: {
        group: "Product List",
        displayName: "Columns",
        allowedContexts: ["ProductListPage"],
        fieldDefinitions: [
            {
                name: fields.hideFilterCheckbox,
                displayName: "Checkbox",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                tooltip: "Change only for collaborater Page",
            },
        ]
    },
};

export default widgetModule;
